<template>
  <div>
    <div v-if="$page.props.flash">
      <v-snackbar
        v-for="(value, prop, i) in $page.props.flash"
        :key="i"
        v-model="flash[prop]"
        dismissible
        :color="prop"
        app
        top
      >
        <strong>{{ value }}</strong>
        <template #action="{ attrs }">
          <v-btn color="white" icon v-bind="attrs" @click="flash[prop] = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    <template v-for="(alert, i) in alerts">
      <v-snackbar
        :key="i"
        :color="alert.type"
        :value="true"
        app
        top
        dark
        @input="removeAlert(i)"
      >
        <strong>{{ alert.message }}</strong>
        <template #action="{ attrs }">
          <v-btn color="white" icon v-bind="attrs" @click="removeAlert(i)">
            <v-icon>mdi-clos-circle</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Alert',
  data() {
    return {
      flash: {
        error: null,
        success: null,
        warning: null,
      },
    }
  },
  computed: {
    ...mapGetters(['alerts']),
  },
  watch: {
    '$page.props.flash': {
      deep: true,
      intermediate: true,
      handler(value) {
        for (const prop in value) {
          this.flash[prop] = value[prop]
          console.log(this.flash[prop])
        }
      },
    },
  },
  methods: {
    ...mapMutations(['removeAlert']),
  },
}
</script>

<style scoped></style>
